import cn from 'classnames';
import React from 'react';

const Meta: React.FC<{
  icon?: string;
  text: string;
}> = ({ icon, text }) => (
  <div
    className={cn(
      'jg-display-flex jg-flex-aic',
      'jg-space-mbxs jg-space-mbn@lg'
    )}
  >
    {icon && (
      <img
        src={icon}
        className={cn(
          'jg-search-result-card__meta-icon',
          'jg-space-mrxs@md',
          'jg-flex-s0 jg-flex-g0 jg-opacity-75'
        )}
        alt=""
      />
    )}
    <p
      className={cn(
        'jg-search-result-card__meta-text',
        'jg-text--medium-light jg-color--nobel',
        'jg-whitespace-no-wrap',
        'jg-flex-g1 jg-flex-s1',
        'jg-space-mbn'
      )}
    >
      {text}
    </p>
  </div>
);
export default Meta;
